export const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://super-condutores.com';
export const frontendUrl = process.env.REACT_APP_FRONTEND_URL || 'https://super-condutores.com';
